import {Component, OnInit} from '@angular/core';
import {SortDirection} from 'app/models/sort-direction.enum';
import {SortFile} from 'app/models/sort-file.enum';
import {AssetsFactory} from 'app/services/assets.factory.services'
import { Observable } from 'rxjs';
import {UPTOPResult} from 'app/models/uptop'
import {Source} from 'app/models/source.enum'
import {IFile} from 'app/models/file'
import {GoogleTagManagerService} from '../../../services/google-tag-manager.service';
@Component({
    selector: 'app-column-sort',
    template: '',
    styleUrls: []
})
export class ColumnSortComponent implements OnInit {

    sort: SortFile;
    direction: SortDirection;
    assets: IFile[]; //lets avoid any
    assetType: Source;
    SortName = SortFile;
    Direction = SortDirection;

    constructor(
      private assetFactory: AssetsFactory,
      private csGtmService: GoogleTagManagerService = null,
    ) {}

    onColumnSort(sort: SortFile): void {
        if (this.sort !== sort) {
            this.sort = sort;
            this.direction = SortDirection.Ascending;
        } else {
            this.direction = this.direction === SortDirection.Descending
                ? SortDirection.Ascending
                : SortDirection.Descending;
        }
        this.getListSorted(this.sort, this.direction).subscribe(r=>{
            this.assets= r.Items;
        });
        if (this.csGtmService !== null) {
          // Changed until new tag plan resolvement
          this.csGtmService.pushEvent(`Sort by - ${sort} - ${this.direction}`);
        }
    }


    getListSorted(sort: SortFile, direction: SortDirection): Observable<UPTOPResult> {

        return this.assetFactory.getInstance(this.assetType).getAll(undefined, (sort&&direction)?`${sort}_${direction}`:undefined);
    }



    ngOnInit() {
        this.sort = SortFile.Filename;
        this.direction = SortDirection.Ascending;
    }

}
